import moment from 'moment'
export function getTheDate(timestamp, format) {
    const time = timestamp * 1000;
    const formatDate = format || 'MM-DD-YYYY';
    return moment(time).format(formatDate);
  }